var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toptips"},[_c('span',[_vm._v(_vm._s(_vm.tips))]),(_vm.hasSolt)?[_c('p',{staticClass:"line"})]:_vm._e(),_c('div',{staticClass:"operate"},[_vm._t("default")],2)],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-307e80d8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toptips.vue
// module id = null
// module chunks = 